import { render } from "./ListDeliveryMan.vue?vue&type=template&id=6350e878&scoped=true"
import script from "./ListDeliveryMan.vue?vue&type=script&lang=js"
export * from "./ListDeliveryMan.vue?vue&type=script&lang=js"

import "./ListDeliveryMan.vue?vue&type=style&index=0&id=6350e878&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6350e878"]])

export default __exports__